<template>
  <div class="d-flex-column align-start gap-18 contact_banner">
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1391 3.45907L7.10914 6.45907C1.03914 8.48907 1.03914 11.7991 7.10914 13.8191L9.78914 14.7091L10.6791 17.3891C12.6991 23.4591 16.0191 23.4591 18.0391 17.3891L21.0491 8.36907C22.3891 4.31907 20.1891 2.10907 16.1391 3.45907ZM16.4591 8.83907L12.6591 12.6591C12.5091 12.8091 12.3191 12.8791 12.1291 12.8791C11.9391 12.8791 11.7491 12.8091 11.5991 12.6591C11.3091 12.3691 11.3091 11.8891 11.5991 11.5991L15.3991 7.77907C15.6891 7.48907 16.1691 7.48907 16.4591 7.77907C16.7491 8.06907 16.7491 8.54907 16.4591 8.83907Z"
        fill="#FF9E48"
      />
    </svg>
    <h1 class="title-h1 t-white font-family-1 f-w-600">
      {{ $t("contact.contact_us") }}
    </h1>
    <p class="t-light font-family-2 regular-xxl" style="max-width: 50ch">
      {{ $t("contact.contact_us_dec") }}
    </p>
    <a
      href="javascript:;"
      @click="openChat"
      class="primary filled xl height-48 full-width max-width-213px b-radius-9 body-l f-w-600 font-family-1"
      >{{ $t("contact.lets_talk") }}</a
    >
  </div>
</template>
<script setup>
const { openChat } = useCrispComposable();
</script>
